import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { doTransition, doWaitImageByTime, isAnnGF, isMCCheatedWithJenny } from "../helpers/helpers";
import { V9EmilyMorningDay2After } from "./V9";
import { emily } from "../characters/Emily";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

const v9 = images.v9;
export const V9EmilyMorningDay2 = async (): Promise<any> => {
    doTransition(v9.V9EmilyMorningDay2_8);
    mc.think(`Emily!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_26);
    mc.talk(`Good morning!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_27);
    emily.talk(`Good morning!`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_3);
    emily.talk(`Join me!`);

    doWaitImageByTime(images.v9.V9EmilyMorningDay2_5);
    emily.talk(`Ok, go.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Go where?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_28);
    emily.talk(`You know! Tell me about our blonde neighbor!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`What do you want to know?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_29);
    emily.talk(`Everything!`);
    emily.talk(`But you can start with the photo she sent you yesterday.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Well, she just wanted to ask if she should post a photo on Insta.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_29);
    emily.talk(`Let me see them!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`You've already seen them.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_30);
    emily.talk(`Come on! I didn't get a good look!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Mmm...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_5);
    emily.talk(`Hey! Don't make me regret telling you about her the other day!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Pff... Alright...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_13);
    mc.talk(`Here.`);

    doWaitImageByTime(images.v9.V9EmilyMorningDay2_31);
    emily.talk(`Oh wow! Very revealing!`);
    emily.talk(`No wonder she asked you before posting it!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_33);
    emily.talk(`What did you say, by the way?`);
    if (Question.globalAnswers.v9ToldAlexToPostHerPic) {
        mc.talk(`I told her she should post it.`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_10);
        emily.talk(`Wow, did she?`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
        mc.talk(`Yup.`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_5);
        emily.talk(`Very brave!`);

    } else {
        doWaitImageByTime(images.v9.V9EmilyMorningDay2_4);
        mc.talk(`I told her she shouldn't post them.`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_5);
        emily.talk(`And she listened?`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
        mc.talk(`Yup.`);
    }

    if (isAnnGF()) {
        doWaitImageByTime(images.v9.V9EmilyMorningDay2_34);
        emily.talk(`Does your girlfriend know she sends you these kinds of photos?`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
        mc.talk(`Mmm... I'm not sure, but I also don't think she'd mind.`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_34);
        emily.talk(`Haha, and what makes you say that?`);

        ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
        mc.talk(`Well... She asked for my help to take Alex out on a date and show her a good time.`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_35);
        emily.talk(`Haha, very funny.`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
        mc.talk(`I'm serious.`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_35);
        emily.talk(`That's crazy! What if things go too far?`);
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_12);
        mc.talk(`That's what I asked. She said she'd be glad if it didn't, but she won't stop me either.`);
    } else {
        // TODO: ANN HATE
        // mc.talk(`TODO: MC TELLS EMILY ABOUT ANN AND ALEX`);
    }

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_35);
    emily.talk(`Did you agree?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_12);
    mc.talk(`I did, we're meeting tonight.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_35);
    emily.talk(`What a player!`);
    emily.talk(`Where are you going?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
    mc.talk(`I think I'll take her to a bar for a drink or two.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_34);
    emily.talk(`Seriously?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
    mc.talk(`Yes, what's wrong with that?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_34);
    emily.talk(`You were basically asked to give her the date of her dreams, and you're taking her to a bar?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
    mc.talk(`No one mentioned the date of her dreams...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_34);
    emily.talk(`Don't be naive!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
    mc.talk(`...`);
    mc.talk(`I guess you have something better in mind.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_34);
    emily.talk(`Take her to a fancy restaurant. In fact you should go to Mon Suricat Préféré.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_11);
    mc.talk(`That's boring...`);
    mc.talk(`And even if it wasn't, I don't think I can afford it.`);

    doWaitImageByTime(images.v9.V9EmilyMorningDay2_10);
    emily.talk(`I'll take care of it for you!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Aren't you broke?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_5);
    emily.talk(`I have enough for that.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Why do I get the impression that this is way too important for you than it should be?`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_5);
    emily.talk(`Haha, I'm just interested to see if you can pull it off.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Interested enough to invest money in it?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_30);
    emily.talk(`I guess!`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_5);
    emily.talk(`So? You interested in my offer?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`Sure, but I still think it's a bad idea.`);
    mc.talk(`Taking me out of my comfort zone will surely screw this date up.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_28);
    emily.talk(`No way! I'll guide you through it.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_4);
    mc.talk(`When?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_29);
    emily.talk(`Right now!`);

    doWaitImageByTime(images.v9.V9EmilyMorningDay2_36, null, 1.5);
    emily.talk(`Alright, so you go and pick her up...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_37);
    emily.talk(`She opens the door.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_38);
    emily.talk(`What do you say?`);
    mc.talk(`Sup?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_39);
    emily.talk(`No! Haha! You compliment her on her clothing.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_38);
    mc.talk(`Even if I don't like it?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_39);
    emily.talk(`Duh!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_38);
    mc.talk(`Got it. What's next?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_40);
    emily.talk(`Listen to her talk and respond!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_41);
    mc.talk(`Wow, that's something I've never thought of.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_42);
    emily.talk(`You'd be surprised how many guys skip this one and just grunt!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_43);
    emily.talk(`Is she a talker or a listener?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_36);
    mc.talk(`I'm not sure... She talks when she has something to say.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_37);
    if (isMCCheatedWithJenny()) {
        mc.talk(`Talking about talkers... There's this girl Jenny I know.`);
        emily.talk(`Focus!`);
    }
    emily.talk(`How are you going to get to the restaurant? By car or on foot?`);
    mc.talk(`It really depends on her...`);
    mc.talk(`I wouldn't mind walking. Anything to avoid picking her up in your pink car.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_39);
    emily.talk(`Haha! That would secure the deal for sure!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_40);
    emily.talk(`Anyway, if you're walking, make sure to match your pace to hers.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_41);
    emily.talk(`She might be wearing high heels, you don't want to speed her up.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_41);
    mc.talk(`Got it.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_42);
    emily.talk(`Besides that, just make your way to the restaurant.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_43);
    emily.talk(`I trust you to get the conversation going.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_36);
    emily.talk(`Now, once you arrive at the restaurant, make sure you open the door for her and let her enter first!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_37);
    emily.talk(`And before you sit down, pull the chair out for her!`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_38);
    mc.talk(`Are you serious? It's not a romantic movie, no one does that.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_39);
    emily.talk(`Exactly! That's what will make you stand out!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_40);
    mc.talk(`Did you forget it's not a real date?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_41);
    emily.talk(`Exactly.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_42);
    emily.talk(`You were asked to give her the date of her dreams! So do that.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_43);
    emily.talk(`Trust me.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_36);
    mc.talk(`Sure... Continue.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_37);
    emily.talk(`Once you sit down, pick something from the menu and order it!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_40);
    emily.talk(`Don't start with 'I don't know what to order' and stuff like that.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_41);
    emily.talk(`Girls like guys who are decisive.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_42);
    emily.talk(`But! Be sure to give her time to pick from the menu. Don't rush her!`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_43);
    mc.talk(`Got it. What else?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_36);
    emily.talk(`I've been to Mon Suricat Préféré, so a waiter will come and suggest wine.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_37);
    emily.talk(`Accept their recommendation.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_38);
    emily.talk(`You want to make her a bit tipsy but not drunk!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_39);
    emily.talk(`A drunk female is a no-no.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_40);
    emily.talk(`She might...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_41);
    emily.talk(`Forget everything in the morning.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_42);
    emily.talk(`... Or she throws up and you can kiss the night goodbye.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_43);
    emily.talk(`... Or she thinks you took advantage of her if something were to happen.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_36);
    emily.talk(`So a bit tipsy is the way to go.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_37);
    mc.talk(`Smart.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_38);
    emily.talk(`Once you finish eating, don't rush for the bill. In fact they have a great pastry chef there so maybe do dessert!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_39);
    emily.talk(`If you're having a nice chat, keep the conversation going.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_40);
    emily.talk(`Only ask for the bill if you feel like you need a change of scenery.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_41);
    emily.talk(`People usually sit quietly after they've paid the bill because they feel like they're waiting for something.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_42);
    emily.talk(`It won't happen in your case because I'll make sure everything is paid for.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_43);
    emily.talk(`So you can just get up and leave.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_36);
    mc.talk(`You really got everything covered, huh?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_37);
    emily.talk(`Haha.`);

    doWaitImageByTime(images.v9.V9EmilyMorningDay2_44);
    emily.talk(`Alright, so you're now at the most important stage.`);
    emily.talk(`Once you leave the restaurant, you should feel closer to each other.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_45);
    emily.talk(`You should already be talking about deeper stuff, not just chit-chat.`);
    emily.talk(`If it feels right, put your hand around her, or hold her hand.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_44);
    emily.talk(`I trust you to know what to do at that point.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_46);
    mc.talk(`You're giving me a lot of directions for someone who trusts me.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_47);
    emily.talk(`Haha, just making sure!`);
    doWaitImageByTime(images.v9.V9EmilyMorningDay2_48);
    emily.talk(`Okay, so now we've reached the most MOST important stage.`);
    emily.talk(`You've reached the front door of her house!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_49);
    mc.talk(`I'm not a baby I know exactly what to do.`);
    doWaitImageByTime(images.v9.V9EmilyMorningDay2_48);
    emily.talk(`Oh yeah?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_50);
    emily.talk(`Follow my lead!`);

    return jump(V9EmilyMorningDay2_Room, "V9EmilyMorningDay2_Room");
};
export const V9EmilyMorningDay2_Room = async (): Promise<any> => {
    doTransition(v9.V9EmilyMorningDay2Room_8);
    emily.talk(`${mc.name}... I had a wonderful night...`);
    mc.think(`Is she role-playing with me?`);
    mc.think(`I can play along.`);
    mc.talk(`I also had a wonderful night.`);
    doWaitImageByTime(v9.V9EmilyMorningDay2Room_1);
    emily.talk(`Wait here...`);
    doWaitImageByTime(v9.V9EmilyMorningDay2Room_2);
    mc.think(`What is she planning?`);
    mc.think(`...`);
    mc.think(`Is she testing how long I'll wait before knocking on her door or something?`);
    mc.think(`Who knows...`);
    mc.think(`...`);
    mc.think(`I'll give her another minute...`);
    doWaitImageByTime(v9.V9EmilyMorningDay2Room_0);
    mc.think(`Holy shit!`);
    emily.talk(`Are you coming inside?`);
    await mc.setQuestion(new Question({ text: "Is she still role-playing or being serious?", options: { think: true }, key: "v9emilyMorningDay2TouchedHer" })
        .option({ title: "Touch her", key: true })
        .option({ title: "End it", key: false }));

    if (Question.globalAnswers.v9emilyMorningDay2TouchedHer) {
        return jump(V9EmilyMorningDay2_Room_Touched, "V9EmilyMorningDay2_Room_Touched");
    }

    mc.talk(`I think I got everything covered!`);
    mc.talk(`Thank you.`);
    return jump(V9EmilyMorningDay2_End, "V9EmilyMorningDay2_End");
};

export const V9EmilyMorningDay2_Room_Touched = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_5);
    mc.talk(`I was waiting for you to invite me inside.`);
    emily.talk(`Haha! I think I got carried away.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_3);
    emily.talk(`I wanted to see what you'd do.`);
    mc.talk(`Did I pass the test?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_4);
    emily.talk(`You did!`);
    doWaitImageByTime(images.v9.V9EmilyMorningDay2Room_6);
    emily.talk(`If a girl changes into something like this, you would have to do something really really dumb to mess it up...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_9);
    emily.talk(`Let me just change back.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_10);
    mc.talk(`Why do you have to change?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_7);
    emily.talk(`Don't know... Isn't it too much? Or little?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_10);
    mc.talk(`Not to me.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_7);
    emily.talk(`Mmm...`);
    emily.talk(`Only if you strip to your underwear as well.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_10);
    mc.talk(`Deal.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_6);
    emily.talk(`Well okay! Let's go to the living room!`);

    doWaitImageByTime(v9.V9EmilyMorningDay2_16);
    mc.talk(`You know... I've never asked you why it's so important for you to move out again.`);
    mc.talk(`I mean... You know this house is usually empty except for me.`);
    mc.talk(`Am I the problem?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_51);
    emily.talk(`Oh no! Not at all!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_52);
    emily.talk(`You know I love having you around!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_53);
    emily.talk(`It's just...`);
    emily.talk(`There are things I can't do around you...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_54);
    mc.talk(`Like?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_53);
    emily.talk(`It might sound silly... But it's those little things...`);
    emily.talk(`For example, I miss just getting out of the shower...`);
    emily.talk(`You know... Naked... Without worrying someone might see me...`);
    emily.talk(`Or sleeping naked... I really love that as well...`);
    emily.talk(`And I don't have to worry about putting on clothes once I get up to go to the bathroom...`);

    mc.talk(`Why can't you do it around me?`);
    doWaitImageByTime(images.v9.V9EmilyMorningDay2_55);
    emily.talk(`${mc.name}! We grew up together; it's too weird!`);
    mc.talk(`That's exactly why it's not weird!`);
    mc.talk(`We used to shower together when we were little.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_56);
    emily.talk(`Yeah... when we were little!`);
    doWaitImageByTime(images.v9.V9EmilyMorningDay2_55);
    if (emily.properties.relation.startsWith('s')) {
        mc.talk(`It's only weird because society says it's weird!`);
    } else {
        mc.talk(`That's just another reason for you to feel more comfortable with me.`);
        mc.talk(`You say that because you think other people might find it weird. Well, I don't.`);
    }
    mc.talk(`I guess you just do what everyone else does...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_57);
    emily.talk(`Hey! That's not true! You know it's not.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    mc.talk(`Alright, it's not.`);
    emily.talk(`...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_59);
    emily.talk(`You don't think it's weird?`);
    mc.talk(`Nope.`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    emily.talk(`Mmm...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_60);
    emily.talk(`Are you sure?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    mc.talk(`Yes.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_60);
    emily.talk(`Are you sure sure?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    mc.talk(`YES!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_60);
    emily.talk(`Your body says something different.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_61);
    mc.think(`Damn, I didn't realize I'm so aroused.`);
    mc.talk(`Can you really blame me? You knew this would happen the moment you opened the door in that outfit!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_60);
    emily.talk(`No, I didn't!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    mc.talk(`Lies.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_60);
    emily.talk(`So... Are you going to take care of it, or...?`);
    emily.talk(`It's distracting...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    mc.talk(`I can. Give me a minute. I'll be right back.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_60);
    emily.talk(`Ha! Who's the one thinking it's weird now?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    mc.talk(`Are you testing me?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_59);
    emily.talk(`You won't do it.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_58);
    mc.talk(`I'll do it right now!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_60);
    emily.talk(`Nah-ah!`);
    // Pulling out.
    doWaitImageByTime(v9.V9EmilyMorningDay2_25);
    emily.talk(`Oh my!`);
    mc.talk(`Told you.`);

    mc.think(`She isn't looking away.`);

    doWaitImageByTime(images.v9.V9EmilyMorningDay2_24);
    mc.think(`Let's see if she will now.`);
    mc.think(`Still looking...`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_22);
    mc.talk(`What about you?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_21);
    emily.talk(`Hmm... I don't have a boner...`);
    mc.talk(`You know what I mean!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_16);
    mc.talk(`If we want to feel more comfortable around each other, you have to play along...`);
    mc.talk(`I played along with your game... It's only fair if you do the same.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_55);
    emily.talk(`I think this is getting out of hand.`);
    mc.talk(`Just try it, and stop if it feels weird.`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_56);
    emily.talk(`Promise not to laugh?`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_55);
    mc.talk(`I won't.`);
    doWaitImageByTime(v9.V9EmilyMorningDay2_17);
    emily.talk(`Okay...`);
    doWaitImageByTime(v9.V9EmilyMorningDay2_18);
    mc.think(`Oh my god, she's actually doing it.`);
    doWaitImageByTime(images.v9.Anim_V9EmilyMCMorningTogether.poster);
    ImageClass.setAnimation(images.v9.Anim_V9EmilyMCMorningTogether);
    mc.think(`This is wild!`);

    ImageClass.setImage(images.v9.V9EmilyMorningDay2_62);
    emily.talk(`I think that's enough feeling comfortable with one another for one day!`);
    mc.think(`No! I didn't finish!`);
    ImageClass.setImage(images.v9.V9EmilyMorningDay2_63);
    mc.talk(`I agree.`);

    endReplay(replayScenesList.V9EmilyMorningDay2_Room_Touched);
    return jump(V9EmilyMorningDay2_End, "V9EmilyMorningDay2_End");
};

export const V9EmilyMorningDay2_End = async (): Promise<any> => {
    // safeguard
    endReplay();
    let anywayOrNot = ``;
    if (Question.globalAnswers.v9emilyMorningDay2TouchedHer) {
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_63);
        anywayOrNot = ` anyway`;
    } else {
        ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_7);
    }
    emily.talk(`You should get ready for your date tonight${anywayOrNot}.`);
    if (Question.globalAnswers.v9emilyMorningDay2TouchedHer) {
        doWaitImageByTime(images.v9.V9EmilyMorningDay2_52);
    } else {
        doWaitImageByTime(images.v9.V9EmilyMorningDay2Room_9);
    }
    emily.talk(`As soon as you get home, I want you to tell me everything!`);
    emily.talk(`I don't care if I'm asleep! Wake me up!`);
    if (Question.globalAnswers.v9emilyMorningDay2TouchedHer) {
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_54);
    } else {
        ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_10);
    }
    mc.talk(`Alright, I'll do that!`);
    if (Question.globalAnswers.v9emilyMorningDay2TouchedHer) {
        ImageClass.setImage(images.v9.V9EmilyMorningDay2_52);
    } else {
        ImageClass.setImage(images.v9.V9EmilyMorningDay2Room_9);
    }

    emily.talk(`Oh! And one last thing.`);
    emily.talk(`Don't you dare show up there with the same clothes you are wearing now.`);
    emily.talk(`Put on something fancy!`);

    return jump(V9EmilyMorningDay2After, "V9EmilyMorningDay2After");
};
